import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__messenger",
  "use": "icon__messenger-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon__messenger\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 10.263C0 4.595 4.925 0 11 0s11 4.595 11 10.263-4.925 10.264-11 10.264c-1.14 0-2.239-.161-3.273-.462L3.982 22v-3.833C1.549 16.284 0 13.443 0 10.263zm9.257.54L3.683 13.75l5.972-6.286 2.887 2.848 5.575-2.946-5.973 6.482-2.887-3.044z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol